<script lang="ts">
import {defineComponent} from 'vue'
import modalKkMixin from "~/components/conversation-club/modal-kk-mixin.js"
import axios from "axios";

export default defineComponent({
  name: "change-expiration-group",
  mixins:[modalKkMixin],
  props:['group', 'organization'],
  data() {
    return {

      expirace: ''
    }
  },
  methods: {
    async saveChanges(){
      try{
        await axios.patch(`/organizations/${this.organization}/groups/${this.group}/change_expiration_group`,
            {expiration_date: this.expirace})
        this.hideModal()
        this.$emit('expiration-changed')
      }catch(e){
        console.log(e)
        alert("Chyba při ukládání změn")
      }

    }
  }

})
</script>

<template>
  <a class="btn btn-outline-primary" href="#" @click.prevent="showModal()">Změnit expiraci všem</a>

  <vue-final-modal v-model="showM" classes="modal-container" content-class="modal-content-f w600">
    <div class="modal-header">
      <b>Změna expirace všem ve skupině</b>
        <button type="button" class="close" @click.prevent="hideModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <i>Působí jen na kurzy přiřazené v rámci organizace</i>
    <div class="form-group ">
          <input type="date" class="form-control" id="start_date" v-model="expirace" >
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click.prevent="hideModal">Zavřít</button>
      <button type="button" class="btn btn-primary" @click.prevent="saveChanges">Nastavit</button>

    </div>
  </vue-final-modal>

</template>

<style scoped>

</style>